<template>
    <div id="mobileMenu">
        <div id="mobileMenuTop">
            <router-link :to="{ name: 'home' }" @click.native="store.mobileMenu = false">Montez Press
                Radio</router-link>
            <img @click="store.mobileMenu = false" src="/static/icons/close.svg" id="close" />
        </div>
        <router-link :to="{ name: 'upcoming' }" @click.native="store.mobileMenu = false">Upcoming</router-link>
        <router-link :to="{ name: 'seriesList' }" @click.native="store.mobileMenu = false">Series</router-link>
        <router-link :to="{ name: 'archive' }" @click.native="store.mobileMenu = false">Archive</router-link>

        <router-link :to="{ name: 'proposal' }" @click.native="store.mobileMenu = false">Submit</router-link>
        <router-link :to="{ name: 'shopList' }" @click.native="store.mobileMenu = false">Shop</router-link>
        <router-link :to="{ name: 'about' }" @click.native="store.mobileMenu = false">About</router-link>

        <router-link v-if="!store.authenticated" :to="{ name: 'login' }"
            @click.native="store.mobileMenu = false">Login</router-link>
        <router-link v-else :to="{ name: 'logout' }" @click.native="store.mobileMenu = false">Logout</router-link>


        <router-link v-if="this.store.cart.items.length" :to="{ name: 'cart' }"
            @click.native="store.mobileMenu = false">Cart ({{ getCartTotalAmount() }})</router-link>

        <router-link :to="{ name: 'subscribe' }" @click.native="store.mobileMenu = false" id="support">Support Montez
            Press
            Radio</router-link>

        <a href="https://radio.montezpress.blog" target="_blank">Blog</a>
        <a href="https://montezpress.com" target="_blank">Press</a>
        <a href="http://instagram.com/montezpressradio" target="_blank">Instagram</a>
        <a href="https://montezpress.us11.list-manage.com/subscribe?u=ad96a1e16c46b57c428adefa3&id=5021009216"
            target="_blank">Newsletter</a>
        <router-link :to="{ name: 'privacy' }" @click.native="store.mobileMenu = false">Privacy Policy</router-link>
        <!--
        <form id="donate" target="_blank" action="https://www.paypal.com/cgi-bin/webscr" method="post">
            <input type="hidden" name="cmd" value="_s-xclick" />
            <input type="hidden" name="hosted_button_id" value="CYMT4JLETZ6GW" />
            <input id="donateSubmit" type="submit" value="Donate" />
        </form>
        -->
        <router-link :to="{ name: 'imprint' }" @click.native="store.mobileMenu = false">Imprint</router-link>
        <!--
        <div id="space"></div>
        <div>A Project by Montez Press</div>
        -->
    </div>
</template>

<script>
import { store } from "../store";
import axios from "axios";

export default {
    name: "MobileMenu",
    data() {
        return {
            store: store,
        };
    },
    methods: {
        getCartTotalAmount() {
            let total = 0;
            this.store.cart.items.forEach((i) => (total += i.amount));
            return total;
        },
        getCookie(cname) {
            var name = cname + "=";
            var decodedCookie = decodeURIComponent(document.cookie);
            var ca = decodedCookie.split(";");
            for (var i = 0; i < ca.length; i++) {
                var c = ca[i];
                while (c.charAt(0) == " ") {
                    c = c.substring(1);
                }
                if (c.indexOf(name) == 0) {
                    return c.substring(name.length, c.length);
                }
            }
            return "";
        },
        logout() {
            let myself = this;
            axios.defaults.headers.common["X-CSRFToken"] =
                this.getCookie("csrftoken");
            axios.post("/api/logout").then(() => {
                localStorage.removeItem("authenticated");
                localStorage.removeItem("giftEligible");
                localStorage.removeItem("userID");
                localStorage.removeItem("lastPayed");
                myself.store.authenticated = false;
                myself.store.giftEligible = true;
                myself.store.userID = 0;
                myself.store.lastPayed = null;
                myself.store.valid = false;
            });
        },
    },
    created() {
        axios.get("/api/login-set-cookie");
    },
};
</script>

<style scoped>
#mobileMenu {
    width: calc(100vw -2rem);
    height: calc(100vh - 1.5rem);
    display: flex;
    padding: 0.7rem 1rem 0.8rem;
    flex-direction: column;
    background-color: white;
}

#menu>a {
    margin-right: 1rem;
}

a,
form,
#logout {
    margin-bottom: 0.25rem;
}

#mobileMenuTop {
    display: flex;
    flex-direction: row;
    justify-content: space-between;
}

#close {
    width: 1rem;
    height: 1rem;
    margin-top: 0.4rem;
}

#space {
    flex-grow: 1;
}

#donate {
    display: inline;
    margin-right: 1rem;
}

#donateSubmit {
    border: none;
    background-color: transparent;
    margin: 0;
    padding: 0;
    cursor: pointer;
    font-family: "Montez Large";
    font-size: 1.333rem;
    color: black;
    text-align: left;
}

#support {
    width: 100%;
    padding: 0.65rem 1rem 0.85rem;
    border: 1px solid black;
    text-align: center;
    box-sizing: border-box;
    margin: 1.3rem 0 1.3rem;
    background-color: #f9f57d;
}

#support:hover {
    background-color: black;
    color: #f9f57d;
}

#live,
#playing {
    font-family: "Montez Small";
    font-size: 1rem;
    /*margin-top: 0.25rem;*/
    margin-left: 1rem;
    animation: blink-animation 2s steps(2, start) infinite;
    -webkit-animation: blink-animation 2s steps(2, start) infinite;
    white-space: nowrap;
}

@keyframes blink-animation {
    to {
        visibility: hidden;
    }
}

@-webkit-keyframes blink-animation {
    to {
        visibility: hidden;
    }
}

#logout {
    cursor: pointer;
}
</style>
